'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenMessages = function flattenMessages(nestedMessages) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return (0, _keys2.default)(nestedMessages).reduce(function (messages, key) {
        var value = nestedMessages[key];
        var prefixedKey = prefix ? prefix + '.' + key : key;

        if (typeof value === 'string') {
            messages[prefixedKey] = value;
        } else {
            (0, _assign2.default)(messages, flattenMessages(value, prefixedKey));
        }

        return messages;
    }, {});
};

exports.default = flattenMessages;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/flattenMessages.js
// module id = X4s9
// module chunks = 57